import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function PrivateRoute(props) {
  const { Component, colorTheme } = props;
  let navigate = useNavigate();

  const userData1 = JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
    if (!userData1) {
      navigate("/");
    }
  }, []);
  return (
    <Component
      coloredTheme={colorTheme}
      userDataFromStorage={userData1}></Component>
  );
}

export default PrivateRoute;
